module.exports = __webpack_public_path__ + "img/inProgress.d9a13149.svg";